import React from 'react';
import { Label } from '../../atoms/RTCC/label';
import { PullDownOptionForm } from './pullDownOptionForm';

export const AirportOptionForm = (props) => {
    const { id, list, state, onChange, outOrIn } = props;

    return (
        <div className={props.confirmText == null ? "" : "confirmLabelTextWrap flightInput"}>
            <Label label={props.label} className={props.labelClassName} />
            <div style={props.pullDownAreaStyle} className="">
                {props.confirmText == null ?
                    <PullDownOptionForm
                        wrapClassName={props.wrapClassName}
                        labelClassName={props.labelClassName}
                        className={props.className}
                        onChange={() => onChange(id, outOrIn)}
                        id={id}
                        data={list}
                        state={state}
                    />
                    :
                    <Label label={props.confirmText} className="confirmLabelText" />
                }
            </div>
        </div>
    );
}
